// version: "pdfmake": "^0.2.20"

import pdfMake from 'pdfmake/build/pdfmake';
import vfs from './fonts/vfs_fonts';

pdfMake.vfs = vfs;

pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
  DejaVu: {
    normal: "DejaVuSans.ttf",
    bold: "DejaVuSans.ttf",
    italics: "DejaVuSans.ttf",
    bolditalics: "DejaVuSans.ttf",
  },
};

export default pdfMake;